<template>
  <AppGenericInput
    v-model="givenValue"
    component-name="v-autocomplete"
    :items="options"
    :label="label"
    item-value="id"
    item-text="name"
    append-icon="$iconSearch"
    v-bind="inputProps"
  />
</template>

<script>
import { useProfQualificationGroupHelper } from "@composables/masterdata/person/profQualificationGroups";
import { useProfQualificationHelper } from "@composables/masterdata/person/profQualifications";
import AppGenericInput from "./AppGenericInput.vue";

export default {
  name: "AppSelectProfQualification",
  components: { AppGenericInput },
  props: {
    value: {
      type: [String, Array, Object],
      default: null
    },
    profQualificationGroupId: {
      type: String,
      default: null
    },
    disciplineId: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: "ProfQualification"
    },
    inputProps: {
      type: Object,
      default: undefined
    }
  },
  setup() {
    const profQualificationGroup = useProfQualificationGroupHelper();
    const profQualifications = useProfQualificationHelper();
    return {
      ...profQualificationGroup,
      ...profQualifications
    };
  },
  computed: {
    givenValue: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      }
    },
    options() {
      let options = this.masterProfQualificationsActive || [];
      if (this.profQualificationGroupId) {
        options = options.filter(
          item => item.profQualificationGroupId == this.profQualificationGroupId
        );
      }
      if (this.disciplineId) {
        options = options.filter(
          item => item.disciplineId == this.disciplineId
        );
      }
      const items = [];

      this.masterProfQualificationGroupsActive.forEach(group => {
        const profQualifications = [];
        options.forEach(qualification => {
          if (qualification.profQualificationGroupId == group.id)
            profQualifications.push({
              name: qualification.name,
              id: qualification.id,
              group: group.name,
              rank: qualification.rank
            });
        });

        items.push({ header: group.name });
        items.push(
          profQualifications.sort((a, b) => (a.rank > b.rank ? 1 : -1))
        );
        items.push({ divider: true });
      });
      return items.flat();
    }
  }
};
</script>
